import React from 'react'
import { Button, Container, Row, Card, Col } from 'react-bootstrap';
import { NavLink } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCheck } from '@fortawesome/free-brands-svg-icons'
import styles from './QISoftware.module.scss';

const QISoftware = () => {
    return (<>

<Container className='outerContainer'>
            <h1 className="mb-4 centerText">AHRQ QI Software</h1>
            <p className="lead centerText">Putting the power of AHRQ Quality Indicators in your hands.</p>
            <p className="centerText">AHRQ oﬀers free software to help users using the AHRQ QIs generate results that are both accurate and actionable. Use of this free software ensures a standard, trusted approach to quality measurement and means more resources are available for supporting improvements to patient care.</p>
        </Container>
    </>)
}

export default QISoftware;